import { type BaseProductElementProps } from "~/feature/Product/types";
import { useProductContext } from "~/feature/Product/ProductContext";
import { Translation } from "~/common/Translation";
import { styled, Typography, type TypographyProps } from "@mui/material";

type Props = BaseProductElementProps &
  Omit<TypographyProps, "children"> & {
    truncate?: boolean;
  };

export const ShortDescriptionV2 = styled((props: Props) => {
  const product = useProductContext(props);

  return (
    <Typography {...props}>
      <Translation {...product.shortDescription} />
    </Typography>
  );
})(({ truncate }) => ({
  overflow: truncate ? "hidden" : undefined,
  textOverflow: truncate ? "ellipsis" : undefined,
  whiteSpace: truncate ? "nowrap" : undefined,
}));
